import styled from 'styled-components'

import { useUnitTranslate } from 'aem-libs-react-ts/src/hooks/useUnitTranslate'
import type { InputUnitType } from 'aem-libs-ts/src/constants/unitType'
import type { Maybe } from 'aem-libs-ts/src/types/utility'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'
import { type IntlNumberFormatOptions, numberFormat } from 'aem-libs-ts/src/utils/formatting/numbers/numberFormat'


export const ValueStyled = styled.strong`
  font-size: 18px !important;
`

interface ResultValueProps {
  value: Maybe<number> | Maybe<string>
  unitType?: InputUnitType
  unitCustom?: string
  /**
   * @deprecated Use `formatOptions` instead
   */
  separateThousands?: boolean
  testId?: string
  /**
   * @deprecated Use `aria-labelledby` on parent element instead or `id` for aria reference
   */
  ariaLabel?: string
  id?: string
  formatOptions?: IntlNumberFormatOptions
}

export const ResultValue = ({ value, unitType, formatOptions, id, ...unitLabelProps }: ResultValueProps) => {
  const unit = useUnitTranslate(typeof value === 'string' ? +value : value, unitType, unitLabelProps.unitCustom)
  const formattedValue = value?.toLocaleString(undefined, { useGrouping: false })
  const usedTestId = unitLabelProps.testId ?? 'value-unit-label'

  return (
    <ValueStyled data-testid={usedTestId} id={id} aria-labelledby={id}>
      {isDefined(formattedValue) && numberFormat(formattedValue, formatOptions ?? undefined)}
      &nbsp;
      {unit}
    </ValueStyled>
  )
}
